<template>
  <div>
    <div class="wrapper-item">
      <div class="card">
        <div class="card-content">
          <div class="media">
            <div class="media-left">
              <figure class="image is-48x48">
                <img class="is-rounded" :src="item.product.images[0].get_thumbnail_url" alt="Placeholder image">
              </figure>
            </div>
            <div class="media-content">
              <p class="product-name">{{item.product.name}}</p>
            </div>
            <div class="media-right">
              <span class="has-icons">
                <i @click="removeItem(item.product.id)" class="fas fa-trash-alt"></i>
              </span>
            </div>
          </div>

          <div class="content">
            <div class="wrapper-quantity">
              <button class="btn" @click="decrement(item)"><i class="fas fa-cart-arrow-down"></i></button>
              <span>{{item.quantity}}</span>
              <button class="btn" @click="increment(item)"><i class="fas fa-cart-plus"></i></button>
              <span class="measury">Unidad</span>
            </div>
            <p><strong>{{getTotal}}</strong></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {toast } from 'bulma-toast'
export default {
  name: 'CartList',
  props: ['item'],
  methods: {
    removeItem(id){
      this.$store.commit('removeItem',id)
    },
    increment(item) {
      if (item.quantity >= item.product.stock){
        toast({
          message: 'Este producto no cuenta con esa cantidad en el stock \n Por favor ingrese una cantidad menor.',
          type: 'is-warning',
          position: 'bottom-center',
          pauseOnHover: true,
          animate: true,
          dismissible: true,
          duration: 2000
        })
      } else{ 
        this.$store.dispatch('incrementQuantity',item)
      }
    },
    decrement(item) {
      this.$store.dispatch('decrementQuantity',item)
    },
  },
  computed: {
    getFormatMoney() {
      let amount = this.item.product.price
      return accounting.formatMoney(amount, "$", 0, ".", ",");
    },
    getTotal() {
      let amount = this.item.quantity * this.item.product.price
      return accounting.formatMoney(amount, "$", 0, ".", ",");
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  font-family: Arial, Helvetica, sans-serif;
  box-shadow: none;
  border: #7451926c 1px solid;
  margin-bottom: .5rem;
  .card-content{
    padding: .5rem 1rem;
    .content{
      display: flex;
      justify-content: space-between;
    }
    .media{
      align-items: center;
      margin-bottom: .5rem;
    }
  }
}
.fa-trash-alt{
  color: #ef2e54d2;
  cursor: pointer;
  font-size: 20px;
}

.wrapper-quantity{
  display: inline-flex;
  overflow: hidden;
  border-radius: 5px;
  align-items: center;
  font-size: 18px;
  span.measury{
    font-size: 14px;
  }
  .btn{
    border: none;
    outline: none;
    background-color: #e5eff1;
    color: #745192;
    cursor: pointer;
    &:hover {
      background-color: #745192;
      color: #e5eff1;
    }
  }
  span {
    margin: 0 .5rem;
  }
}
</style>